export enum ErrorMessages {
    InvalidToken = 'invalidToken',
    InvalidCredentials = 'invalidCredentials',
    AccountNotActive = 'accountNotActive',
    // 2FA
    InvalidChallengeToken = 'invalidChallengeToken',
    InvalidTwoFactorCode = 'invalidTwoFactorCode',
    TwoFactorAlreadyEnabled = 'twoFactorAlreadyEnabled',
    TwoFactorEnforced = 'twoFactorEnforced',
    TwoFactorNotEnabled = 'twoFactorNotEnabled',
    TooManyTwoFactorAttempts = 'tooManyTwoFactorAttempts',
    /** Wymuszone 2FA, a sesja go nie ma (sprzed flagi lub po resecie ADMINa) – backend unieważnia sesję. */
    TwoFactorRequired = 'twoFactorRequired'
}